import { render, staticRenderFns } from "./AiChatPage.vue?vue&type=template&id=4ffb883c&scoped=true"
import script from "./AiChatPage.vue?vue&type=script&lang=js"
export * from "./AiChatPage.vue?vue&type=script&lang=js"
import style0 from "./AiChatPage.vue?vue&type=style&index=0&id=4ffb883c&prod&lang=scss"
import style1 from "./AiChatPage.vue?vue&type=style&index=1&id=4ffb883c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb883c",
  null
  
)

export default component.exports